import { render } from "./CalendarDays.vue?vue&type=template&id=18243150&scoped=true"
import script from "./CalendarDays.vue?vue&type=script&lang=js"
export * from "./CalendarDays.vue?vue&type=script&lang=js"

import "./CalendarDays.vue?vue&type=style&index=0&id=18243150&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18243150"]])

export default __exports__